import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';

@Component({
    selector: 'fcp-icon-field',
    imports: [IconFieldModule],
    styleUrl: './fcp-icon-field.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.fcp-icon-field--fluid]': 'fluid()'
    },
    template: `<p-iconfield [iconPosition]="iconPosition()" [styleClass]="styleClass()">
        <ng-content />
    </p-iconfield>`
})
export class FcpIconFieldComponent {
    iconPosition = input<IconFieldPosition>(IconFieldPosition.Left);
    styleClass = input<string | undefined>();
    fluid = input<boolean>(false);
}

export enum IconFieldPosition {
    Left = 'left',
    Right = 'right'
}
